import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsString } from '@pit/core';
import { IDtoMandator } from '../interfaces/dto.mandator.interface';

// @dynamic
@JsonObject('DtoMandator')
export class DtoMandator extends ModelEntity implements IDtoMandator {

    constructor(initValues: Partial<IDtoMandator> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('code', String, true)
    public code?: string = null;

    @JsonProperty('codeInternal', String, true)
    public codeInternal?: string = null;

    @JsonProperty('description', String, true)
    public description?: string = null;

    @JsonProperty('name1', String, true)
    public name1?: string = null;

    @JsonProperty('name2', String, true)
    public name2?: string = null;

    @JsonProperty('numberMandator', String, true)
    public numberMandator?: string = null;

    @JsonProperty('useLDAP', Boolean, true)
    public useLDAP?: boolean = false;

    public get fullDescription(): string {
        return UtilsString.stringFormat('{0} - {1}', this.numberMandator, this.fullName).trim();
    }

    public get fullName(): string {
        return UtilsString.stringFormat('{0} {1}', this.name1, this.name2).trim();
    }

}
